import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useToastStore = defineStore('toast-store',  () => {

  const toastId = ref(0)
  const toastQueue = ref([])

  function showToastMessage(message, type, icon) {
    if (Array.isArray(message))
      message.forEach(msg => { addToastToQueue(msg, type, icon) })
    else
      addToastToQueue(message, type, icon)
  }

  function addToastToQueue(message, type, icon) {
    const id = ++toastId.value
    toastQueue.value.push({
      id,
      message,
      type,
      icon
    })
  }

  function removeToastFromQueue(id) {
    const index = toastQueue.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toastQueue.value.splice(index, 1)
    }
  }

  // TODO: fix icons not appearing
  // FIXME: update metadata and apply tags doesn't seem to be working

  return {
    toastId,
    toastQueue,
    showToastMessage,
    removeToastFromQueue
  }
})

